import React, { SVGProps } from 'react';
import { SvgContainer } from '@/components/icon/SvgContainer';

export const SplitIcon = (props: SVGProps<SVGSVGElement>) => (
  <SvgContainer {...props}>
    <path
      d="M7 9.5H17"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />

    <path
      d="M7 14.5H17"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />

    <path
      d="M12 6V18"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
    />

    <circle cx="9.5" cy="9.5" r="1.5" fill="currentColor" opacity="0.6" />

    <circle cx="14.5" cy="14.5" r="1.5" fill="currentColor" opacity="0.6" />
  </SvgContainer>
);
